<template>
  <!-- 外部容器用于整体布局 -->
  <div :key="refreshKey" style="display: flex; flex-wrap: wrap;">
    <!-- PDF 预览对话框 -->
    <el-dialog :before-close="handleCloseDialog" :visible.sync="pdf.dialog" append-to-body width="80%">
      <iframe :src="pdf.dialogPdfUrl" height="600px" type="application/pdf" width="100%"></iframe>
    </el-dialog>

    <!-- 每个内部 div 容器包含一个图片和一个按钮 -->
    <div
        v-for="img in imgsPro"
        :key="img.id"
        :style="{ marginRight: '5px', marginBottom: '5px', width: imgWidth + 'px' }">
      <!-- 图片容器 -->
      <div
          :style="{
          border: '1px solid #cccccc',
          width: imgWidth + 'px',
          height: imgHeight + 'px',
          'border-radius': borderRadius+'px',
          padding: '0px',
          'box-sizing': 'border-box',
          overflow: 'hidden'
        }"
      >
        <el-image
            v-if="!checkType(img.url, ['pdf'])"
            :preview-src-list="imgsPro.filter(imgItem => !checkType(imgItem.url, ['pdf'])).map(item => item.url)"
            :src="img.url"
            :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }"
            fit="fit"
            @click.native="handleClick(img)"
        ></el-image>
        <!-- 对于PDF，不提供预览属性 -->
        <el-image
            v-else
            :src="img.url"
            :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }"
            fit="fit"
            @click.native="handleClick(img)"
        ></el-image>
      </div>
      <!-- 按钮 -->
      <div v-if="showDelBtn" style="text-align: center;">
        <el-button @click="$emit('item-delete', img.id)" type="text" size="mini">删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {utils} from "@/util/utils";

export default {
  props: {
    imgs: Array,
    showDelBtn: {
      type: Boolean,
      default: false,
    },
    imgWidth: {
      type: Number,
      default: 100,
    },
    imgHeight: {
      type: Number,
      default: 100,
    },
    clickView: {
      type: Boolean,
      default: true
    },
    borderRadius: {
      type: Number,
      default: 0
    },
  },

  computed: {
    checkType() {
      return (url, types) => utils.file.checkTypeByUrl(url, types);
    }
  },

  data() {
    return {
      refreshKey: 0,
      pdf: {
        dialog: false,
        dialogPdfUrl: null,
      },
      imgsPro: this.imgs || [],
    };
  },

  watch: {
    imgs: {
      handler(val) {
        this.imgsPro = val;
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    handleClick(img) {
      if (this.checkType(img.url, ['pdf'])) {
        this.showPdf(img.url);
      } else {
        // el-image 的 preview-src-list 将会自动处理图片预览
      }
    },

    showPdf(pdfUrl) {
      this.pdf.dialogPdfUrl = pdfUrl;
      this.pdf.dialog = true;
    },

    handleCloseDialog() {
      this.pdf.dialog = false;
      this.pdf.dialogPdfUrl = null;
    },
  },

  name: "CloudImgs",
};
</script>
